import { useState, useEffect } from 'react';
import { bannerService } from '../../_services/bannerService';

export const useBanner = ({
  initialLogo = '',
  initialText = '',
  initialBackground = '',
  initialButtonText = 'Inscríbete',
  slug = '',
  onEdit,
  isEditable = true,
  notifyError = (msg) => console.error(msg), // Conéctalo a tu Toast
  notifySuccess = (msg) => console.log(msg),  // Conéctalo a tu Toast
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Textos
  const [text, setText] = useState(initialText);
  const [buttonText, setButtonText] = useState(initialButtonText);

  // Archivos y previews
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState(initialLogo);
  const [background, setBackground] = useState(null);
  const [backgroundPreview, setBackgroundPreview] = useState(initialBackground);

  // Sincronizar cuando cambian las props iniciales desde el servidor
  useEffect(() => {
    setText(initialText);
    setButtonText(initialButtonText);
    setLogoPreview(initialLogo);
    setBackgroundPreview(initialBackground);
  }, [initialText, initialButtonText, initialLogo, initialBackground]);

  /**
   * Alternar modo edición o cancelar
   */
  const handleEditToggle = () => {
    if (!isEditable) return;

    if (isEditing) {
      // Si cancela, restaurar previews y descartar los objetos File en memoria
      setLogoPreview(initialLogo);
      setBackgroundPreview(initialBackground);
      setText(initialText);
      setButtonText(initialButtonText);
      setLogo(null);
      setBackground(null);
    }
    setIsEditing(!isEditing);
  };

  /**
   * Manejar cambio de archivo (Logo o Background)
   */
  const handleFileChange = async (e, setFile, setPreview) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const validation = bannerService.validateImage(file);
    if (!validation.valid) {
      notifyError(validation.error);
      // Limpiar input para que el usuario pueda reintentar subir el mismo archivo corregido
      e.target.value = '';
      return;
    }

    setFile(file);
    try {
      const preview = await bannerService.readFileAsURL(file);
      setPreview(preview);
    } catch (error) {
      console.error('Error al leer el archivo:', error);
      notifyError('No se pudo procesar la previsualización de la imagen.');
    }
  };

  /**
   * Guardar cambios
   */
  const handleSave = async () => {
    if (!slug) {
      alert('Error: No se puede guardar porque el slug no está definido.');
      return;
    }

    setIsSaving(true);
    try {
      const response = await bannerService.saveBanner(slug, {
        text,
        buttonText,
        logo,
        background,
      });

      // 👉 CORRECCIÓN: Extraemos 'banner' de response.data
      const { banner } = response.data || {};

      if (banner) {
        if (banner.logo) setLogoPreview(banner.logo);
        if (banner.background) setBackgroundPreview(banner.background);
        if (banner.text !== undefined) setText(banner.text);
        if (banner.buttonText !== undefined) setButtonText(banner.buttonText);
      }

      setLogo(null);
      setBackground(null);
      setIsEditing(false);
      
      if (onEdit) onEdit();
      alert('Banner guardado exitosamente.');
    } catch (error) {
      console.error('Error al guardar el banner:', error);
      alert('Error al guardar. Verifica el formato de la imagen.');
    } finally {
      setIsSaving(false);
    }
  };

  return {
    isEditing,
    isSaving,
    text,
    buttonText,
    logo,
    logoPreview,
    background,
    backgroundPreview,
    setText,
    setButtonText,
    setLogo,
    setLogoPreview,
    setBackground,
    setBackgroundPreview,
    handleEditToggle,
    handleFileChange,
    handleSave,
  };
};